import { TourExpenseDto } from '@/features/dashboard/expenses/types/TourExpenseDto.ts';
import { ExpenseInputData } from '@/features/dashboard/expenses/schemas/expenseSchema.ts';
import {
  CreateTourExpenseRequestDto,
  UpdateTourExpenseRequestDto,
} from '@/features/dashboard/expenses/types/ExpenseRequest.ts';
import dayjs from 'dayjs';

export const expenseMapper = {
  toCreateDto: (form: ExpenseInputData): CreateTourExpenseRequestDto => ({
    tourId: form.tourId,
    costCategoryId: form.costCategoryId,
    amount: { amount: form.amount, currency: form.currency },
    dueDate: dayjs(form.dueDate).format('YYYY-MM-DD'),
    description: form.description || undefined,
  }),

  toUpdateDto: (form: ExpenseInputData): UpdateTourExpenseRequestDto => ({
    costCategoryId: form.costCategoryId,
    amount: { amount: form.amount, currency: form.currency },
    dueDate: dayjs(form.dueDate).format('YYYY-MM-DD'),
    description: form.description || undefined,
  }),

  fromDtoToForm: (dto: TourExpenseDto): ExpenseInputData => ({
    tourId: dto.tourId,
    costCategoryId: dto.costCategoryId,
    amount: dto.amount.amount,
    currency: dto.amount.currency,
    // dayjs parsuje "YYYY-MM-DD" jako lokalną północ; new Date dałby północ UTC
    dueDate: dayjs(dto.dueDate).toDate(),
    description: dto.description ?? '',
  }),
};
